"use client";
import clsx from "clsx";
import Link from "next/link";
import { useState } from "react";

type Props = {
  themeAlias: string;
  destinations: Array<{
    id: number;
    title: string;
    alias: string;
    departureCount: number;
  }>;
};
export const SearchThemeDestinationListContainerClient = ({ themeAlias, destinations }: Props) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="flex flex-wrap gap-2 max-lg:hidden py-2">
      {destinations
        .sort((a, b) => b.departureCount - a.departureCount)
        .map((destination, index) => (
          <Link
            key={destination.id}
            href={`/themes/${themeAlias}/${destination.alias}/`}
            className={clsx("rounded-sm bg-bg-1 text-tx-3 text-sm/4 font-semibold p-2 no-underline transition-colors", {
              "opacity-40 cursor-default": destination.departureCount === 0,
              "group cursor-pointer hover:text-pr-1 hover:bg-bg-2": destination.departureCount !== 0,
              hidden: !showAll && index >= 25,
            })}
          >
            {destination.title}{" "}
            <span className="font-medium text-tx-2 group-hover:text-pr-1 transition-colors">
              ({destination.departureCount})
            </span>
          </Link>
        ))}
      {destinations.length > 25 && (
        <div
          className="cursor-pointer rounded-sm bg-bg-1 text-tx-3 text-sm/4 font-semibold p-2 transition-colors hover:text-pr-1 hover:bg-bg-2"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "Voir moins" : "Voir toutes les destinations"}
        </div>
      )}
    </div>
  );
};
